'use client'
import {
  Card,
  Col,
  LoadMoreSection,
  Row,
  Separator,
  Skeleton,
} from '@repo/ui/components'
import React, { Fragment } from 'react'
import { BalanceProjectItem } from './balance-project.item'
import { useGetOtcHistory } from '@repo/services'
import { BalanceProjectEmptyState } from './balance-project.empty-state'

export const BalanceProjectHistory = ({
  projectId,
}: {
  projectId?: string
}) => {
  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useGetOtcHistory({
      skip: 0,
      limit: 10,
      ...(projectId ? { targetCurrency: projectId } : {}),
      baseCurrency: 'IRR',
    })
  const transactions =
    data?.pages?.flatMap((page) => page.data?.transactions || []) || []

  return (
    <Row className='min-h-screen items-start mb-8xl'>
      <Card className='flex-1' withoutBorder>
        <Col>
          {isLoading && (
            <div className='space-y-2'>
              <Skeleton className='w-full h-20' />
              <Skeleton className='w-full h-20' />
              <Skeleton className='w-full h-20' />
            </div>
          )}
          {transactions?.map((transaction, index) => (
            <Fragment key={transaction.id}>
              {index !== 0 && <Separator />}
              {transaction.order && (
                <BalanceProjectItem
                  showCurrency={!projectId}
                  data={transaction.order}
                  createdAt={transaction.createdAt ?? ''}
                  projectId={projectId ?? ''}
                />
              )}
            </Fragment>
          ))}
          {transactions?.length === 0 && !isLoading && (
            <BalanceProjectEmptyState />
          )}
          <LoadMoreSection
            fetchNextPage={fetchNextPage}
            hasNextPage={hasNextPage}
            isFetchingNextPage={isFetchingNextPage}
            isLoading={isLoading}
          />
        </Col>
      </Card>
    </Row>
  )
}
